(() => {
  const mobile = matchMedia('(max-width: 767px)');
  const headingSelector = 'h1,h2,h3,[data-ploy-heading]';
  const main = document.getElementById('MainContent');
  if (!main) return;
  const path = location.pathname;
  const pageType = path.startsWith('/products/') ? 'product' : path.split('/').filter(Boolean).pop() || 'home';
  document.body.dataset.koppaMobilePage = pageType;

  function reviewDialog() {
    const dialog = document.getElementById('KoppaReviewDialog');
    if (!dialog) return;
    if (!dialog.dataset.ready) {
      dialog.dataset.ready = 'true';
      dialog.addEventListener('click', event => {
        if (event.target === dialog || event.target.closest('[data-koppa-dialog-close]')) { dialog.close(); dialog.hidden = true; }
      });
      dialog.addEventListener('close', () => { dialog.hidden = true; });
      if (location.hash === '#KoppaMobileReviewForm' && dialog.querySelector('[data-review-result]')) { dialog.hidden = false; dialog.showModal(); }
    }
    document.querySelectorAll('.mens-reviews, #product-reviews, .product-reviews, .trio-reviews').forEach(host => {
      if (host.querySelector('.koppa-write-review-trigger')) return;
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'koppa-write-review-trigger';
      button.textContent = dialog.querySelector('h2').textContent;
      button.setAttribute('aria-haspopup', 'dialog'); button.setAttribute('aria-controls', dialog.id);
      button.addEventListener('click', () => { dialog.hidden = false; dialog.showModal(); });
      (host.querySelector('.koppa-container') || host).prepend(button);
    });
  }

  function protocol() {
    if (!path.includes('ghk-cu-trio')) return;
    const faq = main.querySelector('#product-faq');
    faq?.querySelectorAll('details').forEach(item => {
      if (/restock|delivery|shipping|return|ingredients|how often|existing routine/i.test(item.querySelector('summary')?.textContent || '')) item.classList.add('koppa-mobile-omit');
    });
    faq?.querySelectorAll('.protocol-faq-group-heading').forEach(item => item.classList.add('koppa-mobile-omit'));
    const panel = main.querySelector('.koppa-mobile-purchase');
    const source = main.querySelector('.protocol-included');
    if (panel && source && !panel.querySelector('.koppa-protocol-breakdown')) {
      const copy = source.cloneNode(true);
      copy.classList.add('koppa-protocol-breakdown');
      copy.querySelectorAll('[id]').forEach(e => e.removeAttribute('id'));
      copy.querySelectorAll('.protocol-included-item').forEach((item, index) => {
        const note = document.createElement('p');
        note.className = 'koppa-routine-card-line';
        note.textContent = ['Treat: lightweight peptide care for face and neck.', 'Hydrate: replenishing moisture and a softer skin feel.', 'Target: conditioning care for dry areas on face and body.'][index];
        item.querySelector('h3')?.after(note);
      });
      panel.querySelector('.koppa-mobile-details')?.before(copy);
    }
  }

  function policyAccordions() {
    if (!mobile.matches) {
      document.querySelectorAll('.koppa-policy-dropdown').forEach(disclosure => { const links = disclosure.querySelector('.cf-legal'); const home = document.querySelector('[data-koppa-legal-home]'); if (home) home.replaceWith(links); else disclosure.before(links); disclosure.remove(); });
      main.querySelectorAll('.koppa-policy-read').forEach(disclosure => disclosure.replaceWith(...[...disclosure.childNodes].filter(node => node.nodeName !== 'SUMMARY')));
      return;
    }
    document.querySelectorAll('.cf-legal').forEach(links => {
      if (links.closest('.koppa-policy-dropdown')) return;
      const disclosure = document.createElement('details');
      disclosure.className = 'koppa-policy-dropdown cf-col';
      const summary = document.createElement('summary'); summary.textContent = 'Policies & preferences'; summary.className = 'cf-col-head';
      const home = document.createElement('span'); home.hidden = true; home.dataset.koppaLegalHome = ''; links.before(home); disclosure.append(summary, links); (document.querySelector('.cupra-footer .cf-nav') || home.parentElement).append(disclosure);
    });
    const returns = main.querySelector('#refunds-returns');
    if (returns && !returns.querySelector('.koppa-policy-read')) {
      const heading = returns.querySelector('[data-ploy-heading="h2"],h2');
      if (heading) {
        const disclosure = document.createElement('details'); disclosure.className = 'koppa-policy-read';
        const summary = document.createElement('summary'); summary.textContent = 'Expand to Read';
        disclosure.append(summary);
        let next = heading.nextSibling;
        while (next) { const node = next; next = next.nextSibling; disclosure.append(node); }
        returns.append(disclosure);
        if (location.hash === '#refunds-returns') disclosure.open = true;
      }
    }
    main.querySelectorAll('table').forEach(table => {
      // Shipping rows become labeled cards on phones. Derive labels from the
      // same headers so editor changes cannot leave a second copy out of date.
      if (pageType === 'shipping-returns') {
        const headers = [...table.querySelectorAll('thead th')].map(cell => cell.textContent.trim());
        if (headers.length) {
          table.classList.add('koppa-shipping-cards');
          table.setAttribute('role', 'table');
          table.querySelectorAll('thead, tbody').forEach(group => group.setAttribute('role', 'rowgroup'));
          table.querySelectorAll('tr').forEach(row => row.setAttribute('role', 'row'));
          table.querySelectorAll('thead th').forEach(cell => cell.setAttribute('role', 'columnheader'));
          table.querySelectorAll('tbody tr').forEach(row => [...row.cells].forEach((cell, index) => {
            cell.dataset.shippingLabel = headers[index] || '';
            cell.setAttribute('role', cell.tagName === 'TH' ? 'rowheader' : 'cell');
          }));
        }
      }
      // Guide charts and data tables (page-guide) scroll and size themselves.
      if (table.closest('.koppa-table-scroll, .kgp-matrix__scroll')) return;
      const wrapper = document.createElement('div'); wrapper.className = 'koppa-table-scroll'; wrapper.tabIndex = 0;
      wrapper.setAttribute('role','region'); wrapper.setAttribute('aria-label','Shipping rates');
      table.before(wrapper); wrapper.append(table);
      // Wide tables (brand facts has nine columns) need room per column, not
      // the 420px every table gets; journal tables render as stacked cards.
      const cols = table.rows[0] ? table.rows[0].cells.length : 0;
      if (cols >= 5 && !path.startsWith('/blogs/')) wrapper.style.setProperty('--koppa-table-cols', cols);
    });
  }

  function pageSections() {
    if (!mobile.matches) return;
    if (pageType === 'men') {
      main.querySelector('#collection-products')?.classList.add('koppa-men-centered');
      main.querySelector('#routine')?.classList.add('koppa-men-centered');
      [...main.querySelectorAll(headingSelector)].find(h => /the science behind|GHK-Cu. The copper peptide behind/i.test(h.textContent))?.closest('section')?.classList.add('koppa-men-science');
    }
    if (pageType === 'find-your-routine') main.querySelector('.hero')?.classList.add('koppa-quiz-fullbleed');
    if (pageType === 'giving-back') {
      const hero = main.querySelector('.hero');
      const why = [...main.querySelectorAll(headingSelector)].find(h => /why (?:this |it )?matters to us/i.test(h.textContent))?.closest('section');
      if (hero && why && hero.parentElement === why.parentElement && hero.nextElementSibling !== why) hero.after(why);
    }
    if (pageType === 'faq' && !main.querySelector('.koppa-faq-topics')) {
      const headings = [...main.querySelectorAll('[data-ploy-heading="h2"]')].filter(h => /The Science of GHK-Cu|The GHK-Cu Products|Results & Timelines|Ordering & Subscription/i.test(h.textContent));
      const nav = document.createElement('nav'); nav.className = 'koppa-faq-topics'; nav.setAttribute('aria-label','FAQ topics');
      headings.forEach((h,i) => { h.id ||= 'koppa-faq-topic-'+i; const link = document.createElement('a'); link.href = '#'+h.id; link.textContent = ['Ingredients & science','Choosing & using products','Results & expectations','Orders, shipping & returns'][i]; nav.append(link); });
      if (headings.length) main.querySelector('.hero')?.after(nav);
    }
  }

  // Reformat only the mobile copy; retain every word and leave rich merchant HTML intact.
  function purchaseHierarchy() {
    if (!mobile.matches) return;
    main.querySelectorAll('.koppa-mobile-overview .koppa-mobile-content, .koppa-protocol-overview-copy').forEach(source => {
      if (source.dataset.hierarchyReady) return;
      if (source.querySelector('a,img,ul,ol,table,br')) return;
      const paragraphs = source.matches('.koppa-protocol-overview-copy') ? [source.textContent.trim()] : [...source.children].map(p => p.textContent.trim()).filter(Boolean);
      if (!paragraphs.length) return;
      let host = source;
      if (source.tagName === 'P') { host = document.createElement('div'); host.className = source.className; source.replaceWith(host); }
      const phrases = /(?:2% GHK-Cu|0\.5% (?:encapsulated )?GHK-Cu|eight additional peptides|water-light, fragrance-free and silicone-free base|three to four drops|non-greasy finish|50% more product|5% niacinamide|4% squalane|3% jojoba|visible blue capsules|Use after serum|water-free balm|matte finish|hands-free|more than twice the product|Layer the lightweight serum|capsule cream|balm stick)/gi;
      const emphasis = (node, text) => {
        let last = 0;
        for (const match of text.matchAll(phrases)) { node.append(document.createTextNode(text.slice(last, match.index))); const strong = document.createElement('strong'); strong.textContent = match[0]; node.append(strong); last = match.index + match[0].length; }
        node.append(document.createTextNode(text.slice(last)));
      };
      const sentences = text => text.split(/(?<=[.!?])\s+(?=[A-Z])/);
      const first = sentences(paragraphs.shift());
      const lead = document.createElement('p'); lead.className = 'koppa-overview-lead'; lead.textContent = first.shift();
      const list = document.createElement('ul'); list.className = 'koppa-overview-benefits'; list.setAttribute('role','list');
      let closing = null;
      if (paragraphs.length && /^(Face|Body|Neck)\./.test(paragraphs[paragraphs.length - 1])) closing = paragraphs.pop();
      const items = [...first, ...paragraphs.flatMap(sentences)];
      items.forEach(text => { const li = document.createElement('li'); emphasis(li,text); list.append(li); });
      host.replaceChildren(lead);
      if (items.length) host.append(list);
      if (closing) { const p = document.createElement('p'); p.className = 'koppa-overview-routine'; p.textContent = closing; host.append(p); }
      host.dataset.hierarchyReady = 'true';
    });
  }

  function run() { purchaseHierarchy(); reviewDialog(); protocol(); policyAccordions(); pageSections(); }
  run();
  document.addEventListener('DOMContentLoaded',run,{once:true});
  document.addEventListener('shopify:section:load',run);
  mobile.addEventListener('change',run);
  let pending;
  new MutationObserver(() => {
    if (pending) return;
    pending = setTimeout(() => { pending = null; run(); }, 120);
  }).observe(main,{childList:true,subtree:true});
})();
